import React, { Component } from "react";
import PropTypes from "prop-types";

export default class AIScanView extends Component {
  static propTypes = {
    onCancel: PropTypes.func.isRequired,
    onFindDetails: PropTypes.func.isRequired,
    onFindItemDetails: PropTypes.func.isRequired,
    onQuickSave: PropTypes.func,
    onPrefill: PropTypes.func,
    onScanReceipt: PropTypes.func,
    initialStep: PropTypes.number,
    initialData: PropTypes.shape({
      productName: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      manufacturer: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      modelNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
      serialNumber: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
    }),
  };

  constructor(props) {
    super(props);
    const normalizedInitialStep = [1, 2, 3].includes(props.initialStep)
      ? props.initialStep
      : 1;
    const initialData = props.initialData || {};
    this.state = {
      step: normalizedInitialStep,
      images: [null, null, null],
      imageFiles: [null, null, null],
      isScanning: false,
      isQuickSaving: false,
      isScanningReceipt: false,
      priceReceiptImagePreview: "",
      priceReceiptImageFile: null,
      scanError: "",
      checkedItems: {},
      scannedData: {
        productName: initialData.productName || "",
        manufacturer: initialData.manufacturer || "",
        modelNumber: initialData.modelNumber || "",
        serialNumber: initialData.serialNumber || "",
        productDescription: "",
        priceReceipt: "",
        warrantyText: "",
        registrationLink: "",
        productImage: [],
        limitedWarranty: "",
        limitedWarrantyLink: [],
        useCareManual: [],
        receiptsDocs: [],
        smartApp: "",
        smartAppName: "",
        smartAppIOS: "",
        smartAppAndroid: "",
      },
      selectedAssets: {
        productImage: [],
        limitedWarranty: [],
        useCareManual: [],
        receiptsDocs: [],
      },
      missingInfoFields: [],
      showMissingInfo: false,
      isSavingToItem: false, // New state for Quick Save loading
    };
  }

  componentWillUnmount() {
    if (this.state.priceReceiptImagePreview) {
      URL.revokeObjectURL(this.state.priceReceiptImagePreview);
    }
  }

  handleImageChange = (index, event) => {
    const file = event.target.files[0];
    if (file) {
      const newImages = [...this.state.images];
      const newImageFiles = [...this.state.imageFiles];
      newImages[index] = URL.createObjectURL(file);
      newImageFiles[index] = file;
      this.setState({ images: newImages, imageFiles: newImageFiles });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    this.setState((prevState) => ({
      scanError: "",
      scannedData: {
        ...prevState.scannedData,
        [name]: value,
      },
    }));
  };

  hasDataValue = (value) => {
    if (Array.isArray(value)) {
      return value.some((item) =>
        typeof item === "string" ? item.trim() !== "" : Boolean(item),
      );
    }
    if (typeof value === "string") {
      return value.trim() !== "";
    }
    return Boolean(value);
  };

  isItemChecked = (key, value) => {
    if (Object.prototype.hasOwnProperty.call(this.state.checkedItems, key)) {
      return this.state.checkedItems[key];
    }
    return this.hasDataValue(value);
  };

  toggleItemCheck = (key, value) => {
    this.setState((prevState) => {
      const currentChecked = Object.prototype.hasOwnProperty.call(
        prevState.checkedItems,
        key,
      )
        ? prevState.checkedItems[key]
        : this.hasDataValue(value);

      return {
        checkedItems: {
          ...prevState.checkedItems,
          [key]: !currentChecked,
        },
      };
    });
  };

  toggleAssetSelection = (key, url, limit, label) => {
    if (!url) {
      return;
    }

    this.setState((prevState) => {
      const currentSelection = prevState.selectedAssets[key] || [];
      const isSelected = currentSelection.includes(url);

      if (limit === 1) {
        if (isSelected) {
          return { scanError: "" };
        }

        return {
          scanError: "",
          selectedAssets: {
            ...prevState.selectedAssets,
            [key]: [url],
          },
        };
      }

      if (isSelected) {
        return {
          scanError: "",
          selectedAssets: {
            ...prevState.selectedAssets,
            [key]: currentSelection.filter((item) => item !== url),
          },
        };
      }

      if (limit && currentSelection.length >= limit) {
        return { scanError: `You can select up to ${limit} ${label}.` };
      }

      return {
        scanError: "",
        selectedAssets: {
          ...prevState.selectedAssets,
          [key]: [...currentSelection, url],
        },
      };
    });
  };

  nextStep = () => {
    const selectedFiles = this.state.imageFiles.filter(Boolean);
    if (!selectedFiles.length) {
      this.setState({ scanError: "Please upload at least one image." });
      return;
    }

    const payload = {
      imageFiles: selectedFiles,
    };

    this.setState({ isScanning: true, scanError: "" });
    this.props.onFindDetails(payload, (response) => {
      if (!response) {
        this.setState({
          isScanning: false,
          scanError: "Unable to scan images. Please try again.",
        });
        return;
      }

      this.setState((prevState) => ({
        isScanning: false,
        step: 2,
        scannedData: {
          ...prevState.scannedData,
          productName: response.productName || "",
          manufacturer: response.manufacturer || "",
          modelNumber: response.model || response.modelNumber || "",
          serialNumber: response.serial || response.serialNumber || "",
        },
      }));
    });
  };
  nextStepSkip = () => {
    this.setState({ step: 2 });
  };

  prevStep = () => {
    this.setState({ step: 1 });
  };

  handleQuickSave = () => {
    const { scannedData } = this.state;
    const payload = {
      Manufacturer: scannedData.manufacturer || "",
      ProductName: scannedData.productName || "",
      Model: scannedData.modelNumber || "",
      Serial: scannedData.serialNumber || "",
      Validate: true,
    };

    this.setState({
      isQuickSaving: true,
      scanError: "",
      missingInfoFields: [],
      showMissingInfo: false,
    });
    this.props.onFindItemDetails(payload, (response) => {

      console.log("response>>>>>>",response)
      if (!response) {
        this.setState({
          isQuickSaving: false,
          scanError: "Unable to fetch details. Please try again.",
          missingInfoFields: [],
          showMissingInfo: false,
        });
        return;
      }

      this.setState((prevState) => {
        const productImage = Array.isArray(response.productImage)
          ? response.productImage
          : response.productImage
            ? [response.productImage]
            : [];
        const limitedWarrantyLink = Array.isArray(response.limitedWarrantyLink)
          ? response.limitedWarrantyLink
          : response.limitedWarrantyLink
            ? [response.limitedWarrantyLink]
            : [];
        const useCareManual = Array.isArray(response.userAndCareManualLink)
          ? response.userAndCareManualLink
          : response.userAndCareManualLink
            ? [response.userAndCareManualLink]
            : [];
        const receiptsDocs = Array.isArray(response.setupGuide)
          ? response.setupGuide
          : response.setupGuide
            ? [response.setupGuide]
            : [];
        const missingInfoFields = this.getMissingFieldLabels(response);
        const showMissingInfo = missingInfoFields.length > 0;

        return {
          isQuickSaving: false,
          step: 3,
          missingInfoFields,
          showMissingInfo,
          scannedData: {
            ...prevState.scannedData,
            manufacturer:
              response.manufacturer || prevState.scannedData.manufacturer || "",
            productName:
              response.productName || prevState.scannedData.productName || "",
            modelNumber:
              response.model || prevState.scannedData.modelNumber || "",
            serialNumber:
              response.serial || prevState.scannedData.serialNumber || "",
            productDescription: response.productDescription || "",
            priceReceipt:  "",
            warrantyText: response.limitedWarrantyText || "",
            registrationLink: response.registrationLink || "",
            productImage,
            limitedWarranty: response.limitedWarranty || "",
            limitedWarrantyLink,
            useCareManual,
            receiptsDocs,
            smartAppName: response.smartAppName || "",
            smartAppIOS: response.smartAppIOS || "",
            smartAppAndroid: response.smartAppAndroid || "",
          },
          selectedAssets: {
            ...prevState.selectedAssets,
            productImage: productImage.slice(0, 1),
            limitedWarranty: limitedWarrantyLink.slice(0, 3),
            useCareManual: useCareManual.slice(0, 3),
            receiptsDocs: receiptsDocs.slice(0, 3),
          },
        };
      });
    });
  };

  getMissingFieldLabels = (response) => {
    const fields = [
      { label: "Product Name", value: response.productName },
      { label: "Manufacturer", value: response.manufacturer },
      { label: "Model Number", value: response.model || response.modelNumber },
      { label: "Serial Number", value: response.serial || response.serialNumber },
      { label: "Product Description", value: response.productDescription },
      { label: "Price", value: response.price },
      { label: "Registration Link", value: response.registrationLink },
      { label: "Product Image", value: response.productImage },
      { label: "Warranty Duration (Months)", value: response.limitedWarranty },
      { label: "Limited Warranty Text", value: response.limitedWarrantyText },
      { label: "Limited Warranty", value: response.limitedWarrantyLink },
      { label: "Use & Care Manual", value: response.userAndCareManualLink },
      { label: "Receipts & Other Docs", value: response.setupGuide },
    ];

    const missing = fields
      .filter((field) => !this.hasDataValue(field.value))
      .map((field) => field.label);

    const hasAnySmartApp =
      this.hasDataValue(response.smartAppName) ||
      this.hasDataValue(response.smartAppIOS) ||
      this.hasDataValue(response.smartAppAndroid);

    if (!hasAnySmartApp) {
      missing.push("Smart App");
    }

    return missing;
  };

  normalizeFieldValue = (value) => {
    if (Array.isArray(value)) {
      const firstValidValue = value.find(
        (item) => typeof item === "string" && item.trim() !== "",
      );
      return firstValidValue ? firstValidValue.trim() : "";
    }
    if (typeof value === "string") {
      return value.trim();
    }
    return value ? String(value).trim() : "";
  };

  handleQuickSaveToItem = () => {
    const { scannedData } = this.state;
    const productName = this.normalizeFieldValue(scannedData.productName);
    const manufacturer = this.normalizeFieldValue(scannedData.manufacturer);
    const modelNumber = this.normalizeFieldValue(scannedData.modelNumber);
    const serialNumber = this.normalizeFieldValue(scannedData.serialNumber);

    const missingFields = [];
    if (!productName) missingFields.push("Product Name");
    if (!manufacturer) missingFields.push("Manufacturer");
    if (!modelNumber) missingFields.push("Model Number");

    if (missingFields.length) {
      this.setState({
        scanError: `Please enter ${missingFields.join(", ")} before Quick Save.`,
      });
      return;
    }

    this.setState({ isSavingToItem: true });

    if (this.props.onQuickSave) {
      this.props.onQuickSave({
        productName,
        manufacturer,
        modelNumber,
        serialNumber,
      });
    }

    this.props.onCancel();
  };

  handlePrefill = () => {
    const { scannedData, selectedAssets, checkedItems } = this.state;

    const isChecked = (key, value) => {
      if (Object.prototype.hasOwnProperty.call(checkedItems, key)) {
        return checkedItems[key];
      }
      return this.hasDataValue(value);
    };

    const prefillData = {};

    // Text fields
    if (isChecked("productName", scannedData.productName)) {
      prefillData.productName = this.normalizeFieldValue(scannedData.productName);
    }
    if (isChecked("manufacturer", scannedData.manufacturer)) {
      prefillData.manufacturer = this.normalizeFieldValue(scannedData.manufacturer);
    }
    if (isChecked("modelNumber", scannedData.modelNumber)) {
      prefillData.modelNumber = this.normalizeFieldValue(scannedData.modelNumber);
    }
    if (isChecked("serialNumber", scannedData.serialNumber)) {
      prefillData.serialNumber = this.normalizeFieldValue(scannedData.serialNumber);
    }
    if (isChecked("productDescription", scannedData.productDescription)) {
      prefillData.productDescription = this.normalizeFieldValue(scannedData.productDescription);
    }
    if (isChecked("priceReceipt", scannedData.priceReceipt)) {
      prefillData.price = this.normalizeFieldValue(scannedData.priceReceipt);
    }
    if (isChecked("warrantyText", scannedData.warrantyText)) {
      prefillData.warrantyText = this.normalizeFieldValue(scannedData.warrantyText);
    }
    if (isChecked("registrationLink", scannedData.registrationLink)) {
      prefillData.registrationLink = this.normalizeFieldValue(scannedData.registrationLink);
    }

    // Receipt photo - include if file exists and checkbox is checked
    if (this.state.priceReceiptImageFile) {
      prefillData.receiptPhotoFile = this.state.priceReceiptImageFile;
    }

    // Warranty Duration (Months) - pass the duration for date calculation
    if (isChecked("limitedWarranty", scannedData.limitedWarranty)) {
      prefillData.warrantyDurationMonths = scannedData.limitedWarranty;
    }

    // URL-based assets (only selected ones)
    if (isChecked("productImage", scannedData.productImage) && selectedAssets.productImage && selectedAssets.productImage.length > 0) {
      prefillData.productImageUrls = selectedAssets.productImage;
    }
    if (isChecked("limitedWarranty", scannedData.limitedWarrantyLink) && selectedAssets.limitedWarranty && selectedAssets.limitedWarranty.length > 0) {
      prefillData.limitedWarrantyUrls = selectedAssets.limitedWarranty;
    }
    if (isChecked("useCareManual", scannedData.useCareManual) && selectedAssets.useCareManual && selectedAssets.useCareManual.length > 0) {
      prefillData.useCareManualUrls = selectedAssets.useCareManual;
    }
    if (isChecked("receiptsDocs", scannedData.receiptsDocs) && selectedAssets.receiptsDocs && selectedAssets.receiptsDocs.length > 0) {
      prefillData.receiptsDocsUrls = selectedAssets.receiptsDocs;
    }

    // Smart App
    if (isChecked("smartAppName", scannedData.smartAppName)) {
      prefillData.smartAppName = scannedData.smartAppName || "";
      prefillData.smartAppIOS = scannedData.smartAppIOS || "";
      prefillData.smartAppAndroid = scannedData.smartAppAndroid || "";
    }

    // Scanned product label images → Service Contract & Others
    const scannedFiles = this.state.imageFiles.filter(Boolean);
    if (scannedFiles.length > 0) {
      prefillData.serviceContractFiles = scannedFiles;
    }

    if (this.props.onPrefill) {
      this.props.onPrefill(prefillData);
    }
  };

  handlePriceReceiptUploadClick = () => {
    if (this.priceReceiptInput) {
      this.priceReceiptInput.click();
    }
  };

  handlePriceReceiptImageChange = (event) => {
    const file = event.target.files && event.target.files[0];
    if (!file) {
      return;
    }

    const allowedExtensions = new Set(["svg", "png", "jpg", "jpeg", "heic"]);
    const allowedMimeTypes = new Set([
      "image/svg+xml",
      "image/png",
      "image/jpeg",
      "image/heic",
      "image/heif",
    ]);
    const fileName = file.name || "";
    const extension = fileName.includes(".")
      ? fileName.split(".").pop().toLowerCase()
      : "";
    const isAllowed =
      allowedMimeTypes.has(file.type) || allowedExtensions.has(extension);
    if (!isAllowed) {
      if (this.priceReceiptInput) {
        this.priceReceiptInput.value = "";
      }
      this.setState({
        scanError:
          "Only SVG, PNG, JPG, JPEG, or HEIC images are allowed for receipt upload.",
      });
      return;
    }

    const previousPreview = this.state.priceReceiptImagePreview;
    const nextPreview = URL.createObjectURL(file);
    if (previousPreview) {
      URL.revokeObjectURL(previousPreview);
    }
    this.setState((prevState) => ({
      priceReceiptImagePreview: nextPreview,
      priceReceiptImageFile: file,
      checkedItems: {
        ...prevState.checkedItems,
        priceReceipt: true,
      },
    }));

    if (!this.props.onScanReceipt) {
      this.setState({ scanError: "Receipt scan service is unavailable." });
      return;
    }

    this.setState({ isScanningReceipt: true, scanError: "" });
    this.props.onScanReceipt({ imageFile: file }, (response) => {
      if (this.priceReceiptInput) {
        this.priceReceiptInput.value = "";
      }

      const parsedValue =
        typeof response === "number" || typeof response === "string"
          ? String(response).trim()
          : "";

      if (!parsedValue) {
        this.setState({
          isScanningReceipt: false,
          scanError: "Unable to scan receipt. Please try again.",
        });
        return;
      }

      this.setState((prevState) => ({
        isScanningReceipt: false,
        scannedData: {
          ...prevState.scannedData,
          priceReceipt: parsedValue,
        },
        checkedItems: {
          ...prevState.checkedItems,
          priceReceipt: true,
        },
      }));
    });
  };

  handleDeletePriceReceiptImage = () => {
    if (this.state.priceReceiptImagePreview) {
      URL.revokeObjectURL(this.state.priceReceiptImagePreview);
    }
    if (this.priceReceiptInput) {
      this.priceReceiptInput.value = "";
    }
    this.setState({ priceReceiptImagePreview: "", priceReceiptImageFile: null });
  };

  renderStep1 = () => (
    <React.Fragment>
      {/* {this.state.isScanning && (
        <p style={{ marginTop: "10px", color: "#4267b2", fontWeight: "bold" }}>
          Scanning images...
        </p>
      )} */}
      <h3 style={{ marginTop: "20px", fontWeight: "bold" }}>
        Scan Product Label
      </h3>

      <div style={{ marginTop: "15px", lineHeight: "1.6", color: "#555" }}>
        <p>1. Upload 1-3 clear photos of the Product Label.</p>
        <p>
          2. We automatically detect manufacturer, product name, model no. &
          serial no.
        </p>
        <p>3. Get manuals & warranty info instantly.</p>
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginTop: "30px",
        }}
      >
        {[0, 1, 2].map((index) => (
          <div
            key={index}
            style={{
              width: "30%",
              height: "150px",
              border: "1px dashed #ccc",
              borderRadius: "10px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              cursor: "pointer",
              position: "relative",
              background: "#f9f9f9",
              textAlign: "center",
              padding: "10px",
            }}
            onClick={() =>
              document.getElementById(`file-upload-${index}`).click()
            }
          >
            {this.state.images[index] ? (
              <img
                src={this.state.images[index]}
                alt={`Upload ${index + 1}`}
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  borderRadius: "10px",
                }}
              />
            ) : (
              <React.Fragment>
                <span style={{ fontSize: "30px", color: "#999" }}>+</span>
                <span
                  style={{ fontSize: "12px", color: "#999", marginTop: "10px" }}
                >
                  Click or tap to upload a photo.
                </span>
              </React.Fragment>
            )}
            <input
              type="file"
              id={`file-upload-${index}`}
              style={{ display: "none" }}
              accept="image/*"
              onChange={(e) => this.handleImageChange(index, e)}
            />
          </div>
        ))}
      </div>

      <div
        style={{
          marginTop: "auto",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <button
          onClick={this.nextStep}
          disabled={this.state.isScanning}
          style={{
            width: "100%",
            padding: "15px",
            backgroundColor: "#5DADF6",
            color: "white",
            border: "none",
            borderRadius: "30px",
            fontSize: "16px",
            fontWeight: "bold",
            cursor: "pointer",
          }}
        >
          {this.state.isScanning ? "Scanning..." : "Find the details"}
        </button>
        {!!this.state.scanError && (
          <p style={{ marginTop: "10px", color: "red", marginBottom: "0" }}>
            {this.state.scanError}
          </p>
        )}
        <button
          onClick={this.nextStepSkip}
          disabled={this.state.isScanning}
          style={{
            marginTop: "15px",
            background: "none",
            border: "none",
            color: "#4267b2",
            fontSize: "16px",
            cursor: this.state.isScanning ? "not-allowed" : "pointer",
            fontWeight: "bold",
            marginBottom: "20px",
            opacity: this.state.isScanning ? 0.6 : 1,
          }}
        >
          Skip
        </button>
      </div>
    </React.Fragment>
  );

  renderStep2 = () => {
    const { scannedData, isSavingToItem, isQuickSaving } = this.state;
    const labelStyle = { color: "#666", fontSize: "14px" };

    const isProductNameValid = this.hasDataValue(scannedData.productName);
    const isManufacturerValid = this.hasDataValue(scannedData.manufacturer);
    const isModelNumberValid = this.hasDataValue(scannedData.modelNumber);
    const areRequiredFieldsFilled =
      isProductNameValid && isManufacturerValid && isModelNumberValid;

    return (
      <React.Fragment>
        <h3 style={{ marginTop: "20px", fontWeight: "bold" }}>
          Preview Information
        </h3>
        <p style={{ color: "#555", lineHeight: "1.5", marginTop: "10px" }}>
          AI extracted the following information from your scanned images.
          Please review and edit if needed.
        </p>

        <div style={{ marginTop: "20px" }}>
          <div className="form-group">
            <label style={labelStyle}>Product Name *</label>
            <input
              type="text"
              name="productName"
              placeholder="Enter product name"
              value={scannedData.productName}
              onChange={this.handleInputChange}
              className="input-field"
            />
          </div>
          <div className="form-group">
            <label style={labelStyle}>Manufacturer *</label>
            <input
              type="text"
              name="manufacturer"
              placeholder="Enter manufacturer"
              value={scannedData.manufacturer}
              onChange={this.handleInputChange}
              className="input-field"
            />
          </div>
          <div className="form-group">
            <label style={labelStyle}>Model Number *</label>
            <input
              type="text"
              name="modelNumber"
              placeholder="Enter Model Number"
              value={scannedData.modelNumber}
              onChange={this.handleInputChange}
              className="input-field"
            />
          </div>
          <div className="form-group">
            <label style={labelStyle}>Serial Number</label>
            <input
              type="text"
              name="serialNumber"
              placeholder="Enter Serial Number"
              value={scannedData.serialNumber}
              onChange={this.handleInputChange}
              className="input-field"
            />
          </div>
        </div>

        <div style={{ marginTop: "auto" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <button
              onClick={this.prevStep}
              style={{
                width: "48%",
                padding: "12px",
                backgroundColor: "#f0f0f0",
                color: "#333",
                border: "none",
                borderRadius: "25px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor:
                  isQuickSaving || isSavingToItem ? "not-allowed" : "pointer",
                opacity: isQuickSaving || isSavingToItem ? 0.7 : 1,
              }}
              disabled={isQuickSaving || isSavingToItem}
            >
              Back
            </button>
            <button
              onClick={this.handleQuickSave}
              disabled={
                !areRequiredFieldsFilled || isQuickSaving
              }
              style={{
                width: "48%",
                padding: "12px",
                backgroundColor: "#2D7EEF",
                color: "white",
                border: "none",
                borderRadius: "25px",
                fontSize: "16px",
                fontWeight: "bold",
                cursor:
                  !areRequiredFieldsFilled || isQuickSaving
                    ? "not-allowed"
                    : "pointer",
                opacity: !areRequiredFieldsFilled || isQuickSaving ? 0.7 : 1,
              }}
            >
              {isQuickSaving ? "Loading..." : "Next"}
            </button>
          </div>
          <button
            onClick={this.handleQuickSaveToItem}
            disabled={
              !areRequiredFieldsFilled || isSavingToItem || isQuickSaving
            }
            style={{
              width: "100%",
              padding: "15px",
              backgroundColor: "#2D7EEF",
              color: "white",
              border: "none",
              borderRadius: "30px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor:
                !areRequiredFieldsFilled || isSavingToItem || isQuickSaving
                  ? "not-allowed"
                  : "pointer",
              opacity:
                !areRequiredFieldsFilled || isSavingToItem || isQuickSaving
                  ? 0.7
                  : 1,
              marginBottom: "20px",
            }}
          >
            Quick Save
          </button>
          {!!this.state.scanError && (
            <p
              style={{ marginTop: "-10px", color: "red", marginBottom: "15px" }}
            >
              {this.state.scanError}
            </p>
          )}
        </div>
      </React.Fragment>
    );
  };

  renderStep3 = () => {
    const { scannedData, missingInfoFields, showMissingInfo } = this.state;
    const labelStyle = { color: "#666", fontSize: "14px" };
    const checkmarkStyle = {
      color: "white",
      backgroundColor: "#4267b2",
      borderRadius: "50%",
      width: "24px",
      height: "24px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      marginRight: "10px",
      marginTop: "25px",
      flexShrink: 0,
      cursor: "pointer",
    };

    const renderFieldWithCheck = (
      label,
      name,
      placeholder,
      multiline = false,
      showImagePicker = false,
    ) => {
      const isChecked = this.isItemChecked(name, scannedData[name]);

      return (
        <div
          className="form-group"
          style={{
            display: "flex",
            alignItems: "flex-start",
            marginBottom: "15px",
          }}
        >
          <div
            style={{
              ...checkmarkStyle,
              backgroundColor: isChecked ? "#4267b2" : "#fff",
              border: isChecked ? "none" : "1px solid #4267b2",
            }}
            onClick={() => this.toggleItemCheck(name, scannedData[name])}
          >
            {isChecked ? "✓" : ""}
          </div>
          <div style={{ flex: 1 }}>
            <label style={labelStyle}>{label}</label>
            {multiline ? (
              <textarea
                name={name}
                placeholder={placeholder}
                value={scannedData[name] || ""}
                onChange={this.handleInputChange}
                className="input-field"
                style={{ height: "80px", fontFamily: "Arial, sans-serif" }}
              />
            ) : (
              <div
                style={{ display: "flex", alignItems: "center", gap: "8px" }}
              >
                <input
                  type="text"
                  name={name}
                  placeholder={placeholder}
                  value={scannedData[name] || ""}
                  onChange={this.handleInputChange}
                  className="input-field"
                />
                {showImagePicker && (
                  <React.Fragment>
                    <button
                      type="button"
                      onClick={this.handlePriceReceiptUploadClick}
                      disabled={this.state.isScanningReceipt}
                      title="Upload receipt image"
                      style={{
                        border: "1px solid #4267b2",
                        background: this.state.isScanningReceipt
                          ? "#dbeafe"
                          : "#fff",
                        color: "#4267b2",
                        borderRadius: "8px",
                        width: "40px",
                        height: "40px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: this.state.isScanningReceipt
                          ? "not-allowed"
                          : "pointer",
                      }}
                    >
                      {this.state.isScanningReceipt ? (
                        <span className="ai-scan-loader" />
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                          <polyline points="17 8 12 3 7 8" />
                          <line x1="12" y1="3" x2="12" y2="15" />
                        </svg>
                      )}
                    </button>
                    <input
                      ref={(ref) => {
                        this.priceReceiptInput = ref;
                      }}
                      type="file"
                      accept=".svg,.png,.jpg,.jpeg,.heic,image/svg+xml,image/png,image/jpeg,image/heic,image/heif"
                      onChange={this.handlePriceReceiptImageChange}
                      style={{ display: "none" }}
                    />
                  </React.Fragment>
                )}
              </div>
            )}
            {showImagePicker && !!this.state.priceReceiptImagePreview && (
              <div
                style={{
                  marginTop: "8px",
                  width: "120px",
                  height: "120px",
                  position: "relative",
                }}
              >
                <img
                  src={this.state.priceReceiptImagePreview}
                  alt="Selected receipt"
                  style={{
                    width: "120px",
                    height: "120px",
                    objectFit: "cover",
                    borderRadius: "8px",
                    border: "1px solid #dbeafe",
                  }}
                />
                <button
                  type="button"
                  onClick={this.handleDeletePriceReceiptImage}
                  title="Delete image"
                  style={{
                    position: "absolute",
                    top: "-8px",
                    right: "-8px",
                    width: "24px",
                    height: "24px",
                    borderRadius: "50%",
                    border: "none",
                    background: "#ef4444",
                    color: "#fff",
                    fontWeight: "bold",
                    lineHeight: "24px",
                    textAlign: "center",
                    cursor: "pointer",
                    padding: 0,
                  }}
                >
                  ×
                </button>
              </div>
            )}
          </div>
        </div>
      );
    };

    const renderStatusItem = (
      label,
      key,
      status,
      isImage = false,
      isDocument = false,
    ) => {
      const isChecked = this.isItemChecked(key, status);
      const imageUrls = isImage
        ? (Array.isArray(status) ? status : [status]).filter(
          (url) => typeof url === "string" && url.startsWith("http"),
        )
        : [];
      const documentUrls = isDocument
        ? (Array.isArray(status) ? status : [status]).filter(
          (url) => typeof url === "string" && url.startsWith("http"),
        )
        : [];
      const selectionLimit = isImage ? 1 : isDocument ? 3 : 0;
      const selectableItems = isImage
        ? imageUrls
        : isDocument
          ? documentUrls
          : [];
      const selectedItems = (this.state.selectedAssets[key] || []).filter(
        (item) => selectableItems.includes(item),
      );

      const displayValue = Array.isArray(status)
        ? status.filter(Boolean).join(", ")
        : status;

      return (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "15px",
          }}
        >
          <div
            style={{
              ...checkmarkStyle,
              backgroundColor: isChecked ? "#4267b2" : "#fff",
              border: isChecked ? "none" : "1px solid #4267b2",
              marginTop: 0,
            }}
            onClick={() => this.toggleItemCheck(key, status)}
          >
            {isChecked ? "✓" : ""}
          </div>
          <div>
            <div style={{ fontSize: "14px", color: "#666" }}>{label}</div>

            {(isImage || isDocument) && selectableItems.length ? (
              <div
                style={{
                  marginTop: "6px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "10px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "8px",
                  }}
                >
                  {selectableItems.map((url, index) => {
                    const isSelected = selectedItems.includes(url);

                    // Determine link text based on field type and index
                    let linkText;
                    if (key === 'limitedWarranty') {
                      linkText = index === 0 ? 'limited warranty' : `limited warranty ${index + 1}`;
                    } else if (key === 'useCareManual') {
                      linkText = `Manual link ${index + 1}`;
                    } else {
                      linkText = `Document ${index + 1}`;
                    }

                    return (
                      <div
                        key={`${label}-${index}`}
                        role="button"
                        tabIndex={0}
                        onClick={() =>
                          this.toggleAssetSelection(
                            key,
                            url,
                            selectionLimit,
                            label,
                          )
                        }
                        onKeyDown={(event) => {
                          if (event.key === "Enter" || event.key === " ") {
                            event.preventDefault();
                            this.toggleAssetSelection(
                              key,
                              url,
                              selectionLimit,
                              label,
                            );
                          }
                        }}
                        style={{
                          border: isSelected
                            ? "2px solid #2D7EEF"
                            : "1px solid #ddd",
                          borderRadius: "8px",
                          padding: "6px",
                          cursor: "pointer",
                          display: "flex",
                          alignItems: "center",
                          gap: "6px",
                          backgroundColor: isSelected ? "#eef5ff" : "#fff",
                          maxWidth: "240px",
                        }}
                      >
                        {isImage ? (
                          <img
                            src={url}
                            alt={`${label} ${index + 1}`}
                            style={{
                              width: "80px",
                              height: "80px",
                              objectFit: "cover",
                              borderRadius: "6px",
                            }}
                          />
                        ) : (
                          <div style={{ flex: 1, minWidth: 0 }}>
                            <div style={{
                              fontWeight: "bold",
                              fontSize: "14px",
                              color: "#333",
                              marginBottom: "2px"
                            }}>
                              {linkText}
                            </div>
                            <a
                              href={url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{
                                color: "#2D7EEF",
                                fontSize: "12px",
                                textDecoration: "none",
                                wordBreak: "break-all",
                                display: "block",
                              }}
                              onClick={(event) => event.stopPropagation()}
                            >
                              {url}
                            </a>
                          </div>
                        )}
                        <div
                          style={{
                            width: "18px",
                            height: "18px",
                            borderRadius: "4px",
                            border: isSelected ? "none" : "1px solid #bbb",
                            backgroundColor: isSelected ? "#2D7EEF" : "#fff",
                            color: "#fff",
                            fontSize: "12px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexShrink: 0,
                          }}
                        >
                          {isSelected ? "✓" : ""}
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            ) : (
              <div style={{ fontWeight: "bold", fontSize: "16px" }}>
                {displayValue || ""}
              </div>
            )}
          </div>
        </div>
      );
    };

    return (
      <React.Fragment>
        <style>{`
          @keyframes aiScanSpin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
          .ai-scan-loader {
            width: 16px;
            height: 16px;
            border: 2px solid rgba(66, 103, 178, 0.25);
            border-top-color: #4267b2;
            border-radius: 50%;
            display: inline-block;
            animation: aiScanSpin 0.9s linear infinite;
          }
        `}</style>

        <h3 style={{ fontWeight: "bold" }}>Product Details</h3>

        {showMissingInfo && !!missingInfoFields.length && (
          <div
            style={{
              marginTop: "12px",
              padding: "12px",
              background: "#fff4e5",
              border: "1px solid #f59e0b",
              borderRadius: "8px",
              color: "#7a4b00",
              position: "relative",
            }}
          >
            <button
              type="button"
              onClick={() => this.setState({ showMissingInfo: false })}
              aria-label="Close"
              title="Close"
              style={{
                position: "absolute",
                top: "6px",
                right: "6px",
                width: "24px",
                height: "24px",
                borderRadius: "50%",
                border: "none",
                background: "#f59e0b",
                color: "#fff",
                fontWeight: "bold",
                lineHeight: "24px",
                textAlign: "center",
                cursor: "pointer",
                padding: 0,
              }}
            >
              ×
            </button>
            <div style={{ fontWeight: "bold", marginBottom: "4px" }}>
              Missing product details
            </div>
            <div>
              We couldn't find the following information:{" "}
              {missingInfoFields.join(", ")}
            </div>
          </div>
        )}

        <div style={{ marginTop: "20px" }}>
          {renderFieldWithCheck(
            "Product Name",
            "productName",
            "Enter product name",
          )}
          {renderFieldWithCheck(
            "Manufacturer",
            "manufacturer",
            "Enter manufacturer",
          )}
          {renderFieldWithCheck("Model Number", "modelNumber", "Enter model")}
          {renderFieldWithCheck(
            "Serial Number",
            "serialNumber",
            "Enter serial",
          )}
          {renderFieldWithCheck(
            "Product Description",
            "productDescription",
            "Enter product description",
            true,
          )}
          {renderFieldWithCheck(
            "Price & Receipt",
            "priceReceipt",
            "Enter price & receipt",
            false,
            true,
          )}
          {renderStatusItem(
            "Warranty Duration (Months)",
            "limitedWarranty",
            scannedData.limitedWarranty,
          )}
          {renderFieldWithCheck(
            "Limited Warranty Text",
            "warrantyText",
            "Enter limited warranty text",
            true,
          )}
          {renderFieldWithCheck(
            "Registration Link",
            "registrationLink",
            "Enter registration link",
          )}

          <div style={{ marginTop: "20px" }}>
            {renderStatusItem(
              "Product Image",
              "productImage",
              scannedData.productImage,
              true,
            )}
            {renderStatusItem(
              "Limited Warranty",
              "limitedWarranty",
              scannedData.limitedWarrantyLink,
              false,
              true,
            )}
            {renderStatusItem(
              "Use & Care Manual",
              "useCareManual",
              scannedData.useCareManual,
              false,
              true,
            )}
            {renderStatusItem(
              "Receipts & Other Docs",
              "receiptsDocs",
              scannedData.receiptsDocs,
              false,
              true,
            )}
            {renderStatusItem(
              "Smart App Name",
              "smartAppName",
              scannedData.smartAppName,
            )}
          </div>
        </div>

        <div style={{ marginTop: "auto" }}>
          <button
            onClick={this.handlePrefill}
            disabled={this.state.isScanningReceipt}
            style={{
              width: "100%",
              padding: "15px",
              backgroundColor: "#5DADF6",
              color: "white",
              border: "none",
              borderRadius: "30px",
              fontSize: "16px",
              fontWeight: "bold",
              cursor: this.state.isScanningReceipt ? "not-allowed" : "pointer",
              opacity: this.state.isScanningReceipt ? 0.7 : 1,
              marginBottom: "20px",
            }}
          >
            Prefill this info
          </button>
        </div>
      </React.Fragment>
    );
  };

  render() {
    const { step } = this.state;
    return (
      <div
        className="ai-scan-container"
        style={{
          padding: "20px",
          fontFamily: "Arial, sans-serif",
          display: "flex",
          flexDirection: "column",
          height: "100%",
          minHeight: "600px",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              <span
                style={{
                  color: "inherit",
                  fontWeight: "normal",
                }}
              >
                Step {step} of 3
              </span>
              <div
                style={{
                  display: "flex",
                  gap: "6px",
                  marginTop: "6px",
                }}
              >
                <span
                  style={{
                    height: "2px",
                    width: "24px",
                    backgroundColor: step >= 1 ? "#4267b2" : "#d0d0d0",
                    display: "inline-block",
                  }}
                />
                <span
                  style={{
                    height: "2px",
                    width: "24px",
                    backgroundColor: step >= 2 ? "#4267b2" : "#d0d0d0",
                    display: "inline-block",
                  }}
                />
                <span
                  style={{
                    height: "2px",
                    width: "24px",
                    backgroundColor: step >= 3 ? "#4267b2" : "#d0d0d0",
                    display: "inline-block",
                  }}
                />
              </div>
            </div>
          </div>
          <button
            onClick={this.props.onCancel}
            style={{
              background: "none",
              border: "none",
              fontSize: "20px",
              cursor: "pointer",
            }}
          >
            ×
          </button>
        </div>

        {step === 1 && this.renderStep1()}
        {step === 2 && this.renderStep2()}
        {step === 3 && this.renderStep3()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Projects/Components/Inventory/AIScanView.js